export const tr = {
    more: 'daha fazla'
};
